import { Link } from 'react-router-dom';
import cn from 'classnames';
import Routes from '../Routes';
import header from './HeaderLink.module.scss';
import { ReactComponent as LogoIcon } from '../../styles/images/logo.svg';
import { ReactComponent as DocsLogo } from '../../styles/images/docsLogo.svg';

const HeaderLink = ({ isDocs }) => (
  <Link
    to={Routes.routes.ROOT.path}
    className={cn(header.link__logo, { [header.link__docs]: isDocs })}
  >
    <LogoIcon className={header.link__logo__text} />
    {isDocs && <DocsLogo />}
  </Link>
);

HeaderLink.defaultProps = {
  isDocs: false,
};

export default HeaderLink;
